import { render, staticRenderFns } from "./order-goods.vue?vue&type=template&id=635cb864&scoped=true&"
import script from "./order-goods.vue?vue&type=script&lang=js&"
export * from "./order-goods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635cb864",
  null
  
)

export default component.exports